import { Avatar, Group, Stack, Text } from '@mantine/core';
import { formatName } from 'src/utils/nameFormatting';

type NameCellProps = {
  entity: {
    firstName: string;
    lastName: string;
    emailAddress?: string | null;
  };
  showAvatar?: boolean;
};

export function NameCell({ entity: entity, showAvatar = true }: NameCellProps) {
  const initials = `${entity.firstName.charAt(0)}${entity.lastName.charAt(0)}`.toUpperCase();

  return (
    <Group
      gap="xs"
      style={{
        flexWrap: 'nowrap',
      }}
    >
      {showAvatar && (
        <Avatar
          size={40}
          radius="xl"
          styles={{
            root: {
              border: '1px solid rgba(0, 0, 0, 0.08)',
            },
            placeholder: {
              color: 'var(--mantine-color-gray-7)',
              backgroundColor: 'var(--mantine-color-gray-0)',
              fontWeight: 600,
            },
          }}
        >
          {initials}
        </Avatar>
      )}
      <Stack gap={0}>
        <Text fw={500} size="sm" c="gray.10">
          {formatName(entity.firstName, entity.lastName)}
        </Text>
        <Text fw={400} size="sm" c="gray.7">
          {entity.emailAddress}
        </Text>
      </Stack>
    </Group>
  );
}
